export default "__VITE_ASSET__CdYoxmK7__"